import bem from 'utils/bem';

export const block = bem('refresh-template-list');
